'use es6';

import { combineReducers } from 'redux';
import notificationsReducer from 'ReduxMessenger/reducers/Notifications';
import { auth } from 'FormsUI/reducers/Auth';
import * as UserReducer from 'FormsUI/reducers/User';
import * as UserAttributeReducer from 'FormsUI/reducers/UserAttributes';
import * as GatesReducer from 'FormsUI/reducers/Gates';
import * as DashboardReducer from 'FormsUI/reducers/Dashboard';
import * as EmailSubscriptionsReducer from 'FormsUI/reducers/EmailSubscriptions';
import * as FormDragDropReducer from 'FormsUI/reducers/FormDragDrop';
import formCreation from 'FormsUI/reducers/FormCreation';
import inventory from 'FormsUI/reducers/Inventory';
import * as FormCloningReducer from 'FormsUI/reducers/FormCloning';
import * as FormDeletionReducer from 'FormsUI/reducers/FormDeletion';
import * as FormSelectionReducer from 'FormsUI/reducers/FormSelection';
import * as FormPropertyNavigationTabsReducer from 'FormsUI/reducers/FormPropertyNavigationTabs';
import * as FormOptionsPanelNavigationItemsReducer from 'FormsUI/reducers/FormOptionsPanelNavigationItems';
import * as FormReducer from 'FormsUI/reducers/Form';
import * as SubmissionsReducer from 'FormsUI/reducers/Submissions';
import * as FormDefinitionReducer from 'FormsUI/reducers/FormDefinition';
import * as PortalScopes from 'FormsUI/reducers/PortalScopes';
import * as PropertyCreationReducer from 'FormsUI/reducers/PropertyCreation';
import * as PropertiesReducer from 'FormsUI/reducers/Properties';
import * as FormPreviewReducer from 'FormsUI/reducers/FormPreview';
import * as FormThemesReducer from 'FormsUI/reducers/FormThemes';
import * as RedirectUrlsReducer from 'FormsUI/reducers/RedirectUrls';
import * as SalesforceCampaignsReducer from 'FormsUI/reducers/SalesforceCampaigns';
import * as WorkflowsReducer from 'FormsUI/reducers/Workflows';
import * as HubUsersReducer from 'FormsUI/reducers/HubUsers';
import * as TeamsReducer from 'FormsUI/reducers/Teams';
import * as BusinessUnitsReducer from 'FormsUI/reducers/BusinessUnits';
import * as FileManagerReducer from 'FormsUI/reducers/FileManager';
import * as NotificationPreferences from 'FormsUI/reducers/NotificationPreferences';
import * as UserPreferencesReducer from 'FormsUI/reducers/UserPreferences';
import submissionsBootstrap from 'FormsUI/reducers/SubmissionsBootstrap';
import payments from 'FormsUI/reducers/Payments';
import * as PortalReducer from 'FormsUI/reducers/Portal';
import * as CollectedFormsReducer from 'FormsUI/reducers/CollectedForms';
import * as TemplatesReducer from 'FormsUI/reducers/Templates';
import * as TicketReducer from 'FormsUI/reducers/Ticket';
import * as DialogsAndPanelsReducer from 'FormsUI/reducers/DialogsAndPanels';
import * as CrmSearchReducer from 'FormsUI/reducers/CrmSearch';
import * as BetaOptInReducer from 'FormsUI/reducers/BetaOptIn';
import * as PropertyAnnotations from 'FormsUI/reducers/PropertyAnnotations';
import * as LeadFlowsReducer from 'FormsUI/reducers/LeadFlows';
import leadinSettings from 'FormsUI/reducers/leadinSettings';
import inboxes from 'FormsUI/reducers/Inboxes';
import translateForm from 'FormsUI/reducers/TranslateForm';
import adConsent from 'FormsUI/reducers/AdConsent';
import * as SubmissionStatusReducer from 'FormsUI/reducers/SubmissionStatus';
import * as LegalConsentReducer from 'FormsCommonComponents/reducers/LegalConsent';
import googleFonts from 'ContentData/reducers/GoogleFonts';
import canSpamSettings from 'ContentData/reducers/CanSpamSettings';
import ContentTeamsReducer from 'ContentData/reducers/Teams';
import ContentUsersReducer from 'ContentData/reducers/Users';
import brandSettings from 'ContentData/reducers/Branding';
import AutomationTabReducers from 'ui-forms-editor-automation-lib/reducers/Root';
import customObjects from 'FormsUI/reducers/CustomObjects';
import comparisonTool from 'FormsUI/reducers/ComparisonTool';
import alertActions from 'FormsUI/reducers/alertActions';
import legalConsentOptions from 'FormsUI/reducers/legalConsentOptions';
import dataPrivacySettings from 'forms-utils-lib/dataPrivacySettings/reducers/DataPrivacySettings';
import settings from 'forms-utils-lib/settings/reducer';
const NotificationsReducer = {
  notifications: notificationsReducer
};
export default combineReducers(Object.assign({
  auth,
  dataPrivacySettings,
  customObjects,
  leadinSettings,
  inboxes,
  alertActions
}, CollectedFormsReducer, {
  comparisonTool
}, DashboardReducer, EmailSubscriptionsReducer, FileManagerReducer, FormCloningReducer, {
  formCreation
}, FormDefinitionReducer, FormDeletionReducer, FormDragDropReducer, FormPreviewReducer, FormReducer, FormSelectionReducer, FormPropertyNavigationTabsReducer, FormOptionsPanelNavigationItemsReducer, FormThemesReducer, GatesReducer, HubUsersReducer, LegalConsentReducer, {
  inventory,
  legalConsentOptions
}, NotificationsReducer, NotificationPreferences, {
  payments
}, PortalScopes, PortalReducer, PropertiesReducer, PropertyCreationReducer, RedirectUrlsReducer, SalesforceCampaignsReducer, {
  settings
}, SubmissionsReducer, TeamsReducer, BusinessUnitsReducer, TemplatesReducer, TicketReducer, UserAttributeReducer, UserPreferencesReducer, UserReducer, WorkflowsReducer, DialogsAndPanelsReducer, CrmSearchReducer, BetaOptInReducer, PropertyAnnotations, SubmissionStatusReducer, {
  submissionsBootstrap
}, LeadFlowsReducer, {
  translateForm
}, AutomationTabReducers, {
  adConsent,
  resources: combineReducers({
    googleFonts,
    canSpamSettings,
    teams: ContentTeamsReducer,
    users: ContentUsersReducer,
    brandSettings
  })
}));